class Accordion extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.rootElement = this.shadowRoot.querySelector("div");
    this.triggerElement = this.shadowRoot.querySelector('slot')?.assignedElements()?.[0];
    this.contentElement = this.shadowRoot.querySelector('slot')?.assignedElements()?.[1];

    this.triggerElement?.addEventListener("click", (e) => {
      this.triggerElement.classList.toggle("open");
      this.contentElement.classList.toggle("open");
    })
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  static get observedAttributes() {
    return ['class']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name] = oldValue || newValue;
  }

  set class(val) {
    this.rootElement.classList.toggle(val);
  }

  template() {
    return `
      <div>
        <slot></slot>
      </div>
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      :host > div {
        border: 0.5px solid #CACACA;
        background: #FEFEFE;
        border-radius: 4px;
        width: 100%;
        height: 100%;
      }
    `;
  }
}

class AccordionTrigger extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.rootElement = this.shadowRoot.querySelector("button");
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  static get observedAttributes() {
    return ['class']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name] = oldValue || newValue;
  }

  set class(val) {
    this.rootElement.classList.toggle(val);
  }

  template() {
    return `
      <button>
        <div><slot></slot></div>

        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 10.5L8 6.5L4 10.5" stroke="#03131E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      :host > button {
        padding: 8px 16px;
        width: 100%;
        height: 100%;
        background: transparent;
        border: none;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      :host > button > div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      :host > button > svg {
        transform: rotate(180deg);
      }

      :host > button.open > svg {
        transform: rotate(0deg);
      }
    `;
  }
}

class AccordionContent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.rootElement = this.shadowRoot.querySelector("div");
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `;
  }

  static get observedAttributes() {
    return ['class']
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this[name] = oldValue || newValue;
  }

  set class(val) {
    this.rootElement.classList.toggle(val);
  }

  template() {
    return `
      <div>
        <slot></slot>
      </div>
    `;
  }

  css() {
    return `
      :host {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      :host > div {
        width: 100%;
        height: 100%;
        border-top: 1px solid #CACACA;
        display: none;
        box-sizing: border-box;
      }

      :host > div.open {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
      }
    `;
  }
}

customElements.define("x-accordion", Accordion);
customElements.define("x-accordion-trigger", AccordionTrigger);
customElements.define("x-accordion-content", AccordionContent);